import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "address-table__content" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { GeocodeResult } from "@/geoMap/GeocodeResult";
import { withDefaults } from "vue";
import { AddressTableRow, ScrollContent } from "..";

interface Props {
  modifires?: typeModifires;
  addressList: GeocodeResult[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'address-table',
  props: {
    modifires: { type: [String, Array, Boolean] },
    addressList: {}
  },
  emits: ["moveMap"],
  setup(__props: any, { emit }) {

const props = __props;




const moveMap = (address: GeocodeResult) => {
  emit("moveMap", address);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('address-table', _ctx.modifires))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ScrollContent), { height: '155px' }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.addressList, (ele) => {
            return (_openBlock(), _createBlock(_unref(AddressTableRow), {
              key: ele.address,
              address: ele,
              onMoveMap: moveMap
            }, null, 8, ["address"]))
          }), 128)),
          (!props.addressList || props.addressList.length < 1)
            ? (_openBlock(), _createBlock(_unref(AddressTableRow), { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})